// extracted by mini-css-extract-plugin
export default {"beautifyImage":"BeautifyImage_beautifyImage__d-Pot","blankNode":"BeautifyImage_blankNode__0LXvz","hideImgContent":"BeautifyImage_hideImgContent__ngssE"};